// import React, { useState, useEffect } from 'react';
// import './Callscript.css';

// function CallScript({ accessToken }) {
//   const [callScriptContent, setCallScriptContent] = useState('');

//   useEffect(() => {
//     const fetchCallScript = async () => {
//       try {
//         const response = await fetch('https://salesjet-10097049716.development.catalystappsail.com/callscript', {
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//           },
//         });
//         const data = await response.json();
//         if (data.status === 'success' && data.data.length > 0) {
//           setCallScriptContent(data.data[0].AppConfig.KeyDetailValue);
//         } else {
//           console.error('Failed to fetch call script data');
//         }
//       } catch (error) {
//         console.error('Error fetching call script:', error);
//       }
//     };

//     if (accessToken) {
//       fetchCallScript();
//     }
//   }, [accessToken]);

//   return (
//     <div>
//       {callScriptContent ? (
//         <div dangerouslySetInnerHTML={{ __html: callScriptContent }} />
//       ) : (
//         <p>Loading call script...</p>
//       )}
//     </div>
//   );
// }

// export default CallScript;
import React, { useState, useEffect } from 'react';
import './Callscript.css';

function CallScript({ accessToken }) {
  const [callScriptContent, setCallScriptContent] = useState('');

  useEffect(() => {
    const fetchCallScript = async () => {
      try {
        // 1️⃣ Check if call script exists in localStorage
        const storedScript = localStorage.getItem('callScript');
        if (storedScript) {
          setCallScriptContent(storedScript);
          return; // ✅ Use cached version, no need to fetch
        }

        // 2️⃣ Fetch from backend if not in localStorage
        const response = await fetch(
          'https://salesjet-10097049716.development.catalystappsail.com/callscript',
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        const data = await response.json();
        if (data.status === 'success' && data.data.length > 0) {
          const script = data.data[0].AppConfig.KeyDetailValue;

          // Save to state
          setCallScriptContent(script);

          // Save to localStorage for next time
          localStorage.setItem('callScript', script);
        } else {
          console.error('Failed to fetch call script data');
        }
      } catch (error) {
        console.error('Error fetching call script:', error);
      }
    };

    if (accessToken) {
      fetchCallScript();
    }
  }, [accessToken]);

  return (
    <div>
      {callScriptContent ? (
        <div dangerouslySetInnerHTML={{ __html: callScriptContent }} />
      ) : (
        <p>Loading call script...</p>
      )}
    </div>
  );
}

export default CallScript;
